<template>
  <div class="other-nat">
    <div class="other-nat-page-background" />
    <div class="other-nat-content">
      <h1 class="other-nat-content-title">
        核算检测开单
      </h1>
      <div class="other-nat-content-input-view">
        <van-field v-model="baseInfo.name" readonly label="姓名" />
        <van-field v-model="baseInfo.cardNo" readonly label="卡号" />
        <van-field v-model="baseInfo.idCard" readonly label="证件号" />
        <van-field v-model="baseInfo.phone" readonly label="手机号" />
        <van-field v-model="address" placeholder="请输入" label="地址" />
        <van-field
          v-model="jobs"
          @click="showPickerJobs = true"
          readonly
          clickable
          label="职业"
          placeholder="选择职业"
        />
        <van-field
          v-model="subJobs"
          :disabled="!getSubJobs.length"
          :clickable="getSubJobs.length"
          :placeholder="getSubJobs.length ? '选择职业子类' : '无'"
          @click="getSubJobs.length ? (showPickerSubJobs = true) : ''"
          readonly
          label="职业子类"
        />
        <!-- <div class="other-nat-content-input-view-tips">hahah</div> -->
      </div>

      <div class="other-nat-content-tip">
        <p>注意事项</p>
        <div v-for="(item, index) in tips" :key="index">
          <div></div>
          <span>{{ item }}</span>
        </div>
      </div>
      <div class="other-nat-button">
        <p>轻按下方按钮，即表示您已阅读并了解以上注意事项</p>
        <ph-button @click="commit">确认开单</ph-button>
      </div>
    </div>
    <van-loading v-show="showloading" type="spinner" color="#1989fa" />
    <!-- 职业列表 -->
    <van-popup v-model="showPickerJobs" position="bottom">
      <van-picker
        :columns="getJobs"
        @confirm="jobsConfirm"
        @cancel="showPickerJobs = false"
        item-height="6rem"
        visible-item-count="3"
        show-toolbar
      />
    </van-popup>
    <!-- 子职业列表 -->
    <van-popup v-model="showPickerSubJobs" position="bottom">
      <van-picker
        :columns="getSubJobs"
        @confirm="subJobsConfirm"
        @cancel="showPickerSubJobs = false"
        item-height="6rem"
        visible-item-count="3"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      professions: [],
      baseInfo: {},
      address: "",
      jobs: "",
      jobsId: -1,
      subJobs: "",
      subJobsId: -1,
      showPickerJobs: false,
      showPickerSubJobs: false,
      showloading: flase,
      tips: [
        "该服务功能仅支持本人三码融合码就诊卡开单，提交之前请确认信息是否正确",
        "该服务功能仅支持线上核酸检测开单，采样工作请您到医院现场指定地点按照要求进行采",
        "申请提交成功后，会自动跳转进行结算",
        "如需查询核酸检测报告结果，可通过该公众号首页“检验报告”功能进行查询"
      ]
    };
  },
  computed: {
    getJobs() {
      return this.professions.map(item => {
        return item.itemName;
      });
    },
    getSubJobs() {
      if (this.jobsId > -1 && this.professions[this.jobsId].children) {
        return this.professions[this.jobsId].children.map(item => {
          return item.itemName;
        });
      }
      return [];
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http.post(this.$api.TEST_NUCLEIC_ACID_PROFESSION, {}).then(res => {
        this.professions = res;
      });
      this.$http
        .post(this.$api.TEST_NUCLEIC_ACID_USERINFO, {
          functionType: "1"
        })
        .then(res => {
          this.baseInfo = res;
        });
    },
    commit() {
      // if (!this.address) {
      //   alert("请输入地址");
      //   return;
      // }
      // if (!this.jobs) {
      //   alert("请选择职业");
      //   return;
      // }
      // if (this.getSubJobs.length && !this.subJobs) {
      //   alert("请选择职业子类");
      //   return;
      // }
      this.showloading = true;
      const that = this;
      this.$http
        .post(this.$http.api.TEST_NUCLEIC_ACID_COMMIT, {
          functionType: "1",
          cardType: this.baseInfo.cardType,
          cardNo: this.baseInfo.cardNo,
          name: this.baseInfo.name,
          idCard: this.baseInfo.idCard,
          phone: this.baseInfo.phone,
          lxdz: this.address,
          zyfl: this.jobs,
          zyzfl: this.subJobs
        })
        .then(() => {
          that.$http.route(
            "/med_settle",
            "1",
            `&cardNo=${that.baseInfo.cardNo}`,
            true
          );
        });
    },
    jobsConfirm(content, id) {
      this.jobs = content;
      this.jobsId = id;
      this.showPickerJobs = false;
    },
    subJobsConfirm(content, id) {
      this.subJobs = content;
      this.subJobsId = id;
      this.showPickerSubJobs = false;
    }
  }
};
</script>

<style lang="less">
.other-nat {
  position: relative;
  background: #efeff4;

  .van-cell {
    padding-top: 0.6rem;
    font-size: 0.94rem;
  }
  .van-ellipsis {
    white-space: normal;
  }
  .van-field__label {
    width: 4rem;
    font-weight: 450;
  }

  &-page-background {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 9.63rem;
    background: linear-gradient(180deg, #108eee 0%, rgba(37, 193, 248, 0) 100%);
  }

  &-content {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    overflow: scroll;
    &-title {
      margin-top: 1.19rem;
      color: white;
      font-weight: 600;
      font-size: 1.03rem;
      text-align: center;
    }
    &-input-view {
      margin: 1.19rem;
      padding: 0.5rem 0 1rem 0;
      background: white;
      border-radius: 0.5rem;

      &-tips {
        padding: 0.5rem 1rem;
        color: red;
      }
    }
    &-tip {
      margin: 0.75rem 1.19rem;
      padding-bottom: 1rem;
      background: white;
      border-radius: 0.5rem;

      p {
        padding-left: 0.5rem;
        color: #108eee;
        line-height: 2.31rem;
        background: rgba(16, 142, 238, 0.1);
        border-radius: 0.5rem 0.5rem 0 0;
      }
      > div {
        display: flex;
        padding: 0 0.5rem;
        font-size: 0.81rem;
        div {
          flex-shrink: 0;
          width: 0.3rem;
          height: 0.3rem;
          margin-top: 0.4rem;
          margin-right: 1rem;
          background: #108eee;
          border-radius: 0.3rem;
        }
      }
    }
  }

  &-button {
    bottom: 0;
    width: 100%;
    height: 6rem;
    padding-top: 0.5rem;
    text-align: center;
    background: white;
    p {
      margin: 0.5rem 1rem;
      font-size: 0.69rem;
      line-height: 0.8rem;
    }
  }
}
</style>
